<template>
  <b-modal title="Informações Sobre o Abastecimento" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Tipo:" label-for="tipo" label-cols="3" label-align="right">
            <b-form-input id="tipo" v-model="editing.tipo" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Data:" label-for="data" label-cols="3" label-align="right">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Km:" label-for="km" label-cols="3" label-align="right">
            <b-form-input id="km" v-model="editing.km" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Quantidade:" label-for="qtd" label-cols-sm="3" label-align="right">
            <b-form-input id="qtd" v-model="editing.quantidade" type="number" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Valor:" label-for="valor" label-cols="3" label-align="right">
            <b-form-input id="valor" v-model.lazy="editing.valor" v-money="money" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Responsável:" label-for="responsavel" label-cols="3" label-align="right">
            <b-form-input id="responsavel" v-model="editing.responsavel" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useVeiculoStore } from "@/stores/VeiculoStore";
import Abastecimento from "@/models/Abastecimento";
import Notificacao from "@/models/Notificacao";
import { VMoney } from "v-money";

export default {
  name: "ModalDeEdicaoDeAbastecimento",

  data() {
    return {
      show: false,
      editing: new Abastecimento(0, new Date(), "", "Gasolina - Ethanol - Diesel - GNV", 0, 0, ""),
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },

  directives: { money: VMoney },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.veiculoStore.ALTERAR_ABASTECIMENTO(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Abastecimento salvo no SGCQ com sucesso!", "Excelente!", "success"));
          this.$emit("update");
        });
      } else {
        this.veiculoStore.CADASTRAR_ABASTECIMENTO(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Abastecimento salvo no SGCQ com sucesso!", "Excelente!", "success"));
          this.$emit("update");
        });
      }
      this.show = !this.show;
    },

    call(abastecimento) {
      this.show = !this.show;
      this.editing = abastecimento;
    },
  },

  setup() {
    const store = useSgcqStore();
    const veiculoStore = useVeiculoStore();

    return {
      store,
      veiculoStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
